import React from 'react';
import { observer } from 'mobx-react';
import { action, observable } from 'mobx';
import { Table, Column, Pager, DatePicker, Select, Button } from '@smartplatform/ui';
import store from '../../store';
import './style.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { endOfDay, startOfDay } from 'date-fns';
import debounce from 'lodash/debounce';
import { Link } from 'react-router-dom';
import Report from './Report';

const PER_PAGE = 100;

@observer
export default class Audits extends React.Component {

	@observable records = [];
	@observable isLoading = false;
	@observable createdAt = null;
	@observable page = 1;
	@observable isInitialized = false;
	@observable action = null;
	@observable model = null;
	@observable ownerId = null;
	@observable users = [];
	@observable selectedRecord = null;
	@observable showPopup = false;

	constructor(props) {
		super(props);
		this.init();
		this.doSearch = debounce(this.init, 500, { leading: false, trailing: true });
	};

	@action init = async () => {
		this.isLoading = true;

		const where = {
			ownerId: { neq: null }
		};
		if (this.action) where.action = this.action;
		if (this.model) where.model = { ilike: `%${this.model.trim()}%` };
		if (this.ownerId) where.ownerId = this.ownerId;
		if (this.createdAt) {
			const date = new Date(this.createdAt);
			where.createdAt = { between: [startOfDay(date), endOfDay(date)] }
		};
		this.records = await store.model.Audit.find({
			where,
			include: [
				{
					relation: 'owner', scope: { fields: ['id', 'firstName', 'lastName', 'middleName', 'username'] }
				},

			],
			fields: ["createdAt", "action", "model", "ownerId", "id", "instance"],
			order: 'createdAt desc',
			skip: (this.page - 1) * PER_PAGE,
			limit: PER_PAGE
		});
		this.users = await store.model.User.find({
			fields: ['id', 'firstName', 'lastName', 'middleName', 'username']
		});
		this.isInitialized = true;
		this.isLoading = false;
	};

	onPageChange = async (page) => {
		this.page = page;
		await this.init();
	};
	onCreatedAtChange = async (date) => {
		this.page = 1;
		this.createdAt = date;
		await this.init();
	};
	onActionChange = async (action) => {
		this.page = 1;
		this.action = action;
		await this.init();
	};

	renderOwner = record => {
		const owner = record.owner;
		if (!owner) {
			return;
		}
		const fio = [owner.lastName, owner.firstName, owner.middleName].join(' ').trim();
		return fio || owner.username;
	};
	@action onModelChange = e => {
		this.page = 1;
		this.model = e.target.value;
		this.doSearch();
	};

	onUserChange = async (ownerId) => {
		this.page = 1;
		this.ownerId = ownerId;
		await this.init();
	};

	getUsersList = (id = null) => {
		if (id) {
			const userById = this.users.find((user) => id === user.id);
			return [userById.lastName, userById.firstName, userById.middleName].join(' ').trim() || userById.username;
		};
		return this.users.map((user) => {
			return {
				label: [user.lastName, user.firstName, user.middleName].join(' ').trim() || user.username || 'no user info',
				value: user.id
			}
		}).sort()
	};

	clearFilters = async () => {
		this.page = 1;
		this.createdAt = null;
		this.model = null;
		this.action = null;
		this.ownerId = null;
		await this.init();
	};

	onRowClick = (record) => {
		this.selectedRecord = record;
		this.showPopup = true;
	};
	onPopupClose = () => {
		this.selectedRecord = null;
		this.showPopup = false;
	};


	render() {
		if (!this.isInitialized) return '...';
		const pagerWithLoader = this.isLoading
			? <div className="loading-msg">Загрузка...</div>
			: <Pager itemsPerPage={PER_PAGE} totalCount={this.records.totalCount}
				current={this.page} onChange={this.onPageChange} />
		return (
			<div className="audits-list">
				<div className="filter-block">
					<DatePicker value={this.createdAt} onChange={this.onCreatedAtChange} placeholder="Дата" />
					<Select className="drop-down-md" isRequired value={this.action} onChange={this.onActionChange}
						items={[
							{ label: 'Все действия', value: null },
							{ label: 'create', value: 'create' },
							{ label: 'delete', value: 'delete' },
							{ label: 'update', value: 'update' },
						]} />
					<input className='name-input' value={this.model || ''} placeholder="Поиск модели" onChange={this.onModelChange} />
					<Select items={this.getUsersList()} onChange={this.onUserChange}
						showValue={this.ownerId ? this.getUsersList(this.ownerId) : <span className='author-placeholder'>Поиск по пользователю</span>} className="drop-down-md user-selector" placeholder='имя пользователя' />
					<Button className='btn-primary' onClick={this.clearFilters}>
						<FontAwesomeIcon icon={faFilter} /> очистить </Button>
				</div>
				{pagerWithLoader}
				<Table records={this.records} onRowClick={this.onRowClick}>
					<Column width={90} property="createdAt" label="Время" />
					<Column width={50} property="action" label="Действие" />
					<Column width={100} property="model" label="Модель" />
					<Column width={150} computed={this.renderOwner} label="Пользователь" />
				</Table>
				{this.showPopup && <Report selectedRecord={this.selectedRecord} onClose={this.onPopupClose} />}
			</div >
		)
	}
}


